import { Report } from '../../models/report.model';

export const getTransportLabelFromCode = (
  code: Report.Characteristics.Transport,
): string => {
  switch (code) {
    case Report.Characteristics.Transport.AIRPORT:
      return 'Aéroport';
    case Report.Characteristics.Transport.BUS:
      return 'Bus';
    case Report.Characteristics.Transport.HIGHWAY_ACCESS:
      return 'Accès autoroute';
    case Report.Characteristics.Transport.PARK_AND_RIDE:
      return 'Parking relais';
    case Report.Characteristics.Transport.SUBWAY:
      return 'Métro';
    case Report.Characteristics.Transport.TRAIN_STATION:
      return 'Gare ferroviaire';
    case Report.Characteristics.Transport.TRAMWAY:
      return 'Tramway';
    default:
      return 'Autre';
  }
};
